exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-switch.is-disabled[data-v-1891ea81]{opacity:1}[data-v-1891ea81] .el-switch__label{cursor:pointer !important}.corp-name[data-v-1891ea81]{margin-bottom:20px;padding:10px 0;font-size:16px;font-weight:bold;color:#333;border-bottom:1px solid #e4e7ed}", ""]);

// exports
